import { render, staticRenderFns } from "./WatchPointPrice.vue?vue&type=template&id=45c4d56b&scoped=true"
import script from "./WatchPointPrice.vue?vue&type=script&lang=js"
export * from "./WatchPointPrice.vue?vue&type=script&lang=js"
import style0 from "./WatchPointPrice.vue?vue&type=style&index=0&id=45c4d56b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c4d56b",
  null
  
)

export default component.exports